export const listaPresentacion = [
    { label: 'INPUT', value: 'INPUT' },
    { label: 'DROPDOWN', value: 'DROPDOWN' },
    { label: 'TEXTAREA', value: 'TEXTAREA' },
    { label: 'DATE', value: 'DATE' }
]

export const listaTipoDato = [
    { label: 'DATE', value: 'DATE' },
    { label: 'VARCHAR', value: 'VARCHAR2' },
    { label: 'NUMERIC', value: 'NUMERIC' },
]
